import { render, staticRenderFns } from "./UploadedSuccessView.partial.vue?vue&type=template&id=3a8ec280&scoped=true"
var script = {}
import style0 from "./UploadedSuccessView.partial.vue?vue&type=style&index=0&id=3a8ec280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ec280",
  null
  
)

export default component.exports